var kioskInsights = {};
var ApplicationInsights = {};
(function (kioskInsights, ApplicationInsights, config) {
    var _insightsConfig = {
        config: {
            instrumentationKey: config.INSIGHTS_KEY,
            maxAjaxCallsPerView: -1
        }
    };

    var _regRewrite = [
        {
            regEx : /(pf\/members\/)(.*\/)(.+)/gi,
            rewrite: '$1:memberGuid/$3'
        },
        {
            regEx : /(waivers\/current)(.*)/gi,
            rewrite: '$1$2'
        },
        {
            regEx : /(pf\/waivers\/).+(.*)/gi,
            rewrite: '$1:waiverTitle$2'
        },
        {
            regEx : /(pf\/schedules\/).+(.*)/gi,
            rewrite: '$1:scheduleId$2'
        },
        {
            regEx : /(cancel\/).+(.*)/gi,
            rewrite: '$1:tagId$2,'
        },
        {
            regEx : /(alltagdata\/).+(.*)/gi,
            rewrite: '$1:tagId,'
        },
        {
            regEx : /(tagdata\/).+(.*)/gi,
            rewrite: '$1:tagId,:scheduleId$2,'
        },
        {
            regEx : /(cancel\/).+(.*)/gi,
            rewrite: '$1:tagId,'
        },
        {
            regEx : /(resume\/).+(.*)/gi,
            rewrite: '$1:tagId,:delay$2,'
        },
        {
            regEx : /(pause\/).+(.*)/gi,
            rewrite: '$1:tagId,$2,'
        },
        {
            regEx : /(activateScheduleGUIDbyStaff\/).+(.*)/gi,
            rewrite: '$1:tagId,:delay,:duration,:scheduleId,:operator,$2,'
        },
        {
            regEx : /(activateScheduleGUID\/).+(.*)/gi,
            rewrite: '$1:tagId,:delay,:duration,:scheduleId,$2,'
        },
        {
            regEx : /(activateScheduleGUIDbyStaff2\/).+(.*)/gi,
            rewrite: '$1:tagId,:delay,:duration,:scheduleId,:operator,$2,'
        },
        {
            regEx : /(activateScheduleGUID2\/).+(.*)/gi,
            rewrite: '$1:tagId,:delay,:duration,:scheduleId,$2,'
        },
        {
            regEx : /(.*).+(ADNETWCFSERVICE\/)(.*)/gi,
            rewrite: ':service/$2/$3'
        },
        {
            regEx : /(.*).+(WIFITAGWCFSERVICE\/)(.*)/gi,
            rewrite: ':service/$2/$3'
        },
        {
            regEx : /(kiosk\/).+(\/config)/gi,
            rewrite: '$1:kioskId$2'
        }
    ];

    kioskInsights.fixDynamicPath = function(pathname) {
        for (var i = 0; i < _regRewrite.length; i++) {
            var regex = _regRewrite[i].regEx;
            var rewrite = _regRewrite[i].rewrite;
            if(regex.test(pathname)){
                return pathname.replace(regex, rewrite);
            }
        }
        return pathname;
    };

    kioskInsights.init = function(){
        var clubCode = 'unknown', kioskId = 'unknown';
        var init = new ApplicationInsights.Initialization(_insightsConfig);
        window.appInsights = init.loadAppInsights();

        kioskInsights.ai = appInsights;

        appInsights.context.addTelemetryInitializer(function (envelope) {
            var telemetryItem = envelope.data.baseData;

            if (envelope.name === ApplicationInsights.Telemetry.RemoteDependencyData.envelopeType) {
                telemetryItem.name = kioskInsights.fixDynamicPath(telemetryItem.name);
            }

            try {
              kioskId = common.getKioskIdFromUrl('id');
              clubCode = store(kioskId).clubCode;
            }
            catch(err){}

            // custom properties:
            telemetryItem.properties = telemetryItem.properties || {};
            telemetryItem.properties["clubCode"] = clubCode;
            telemetryItem.properties["kioskId"] = kioskId;
            telemetryItem.properties["kioskBuild"] = config.BUILD;
        });
        appInsights.context.addTelemetryInitializer(function(envelope){
            envelope.tags["ai.cloud.role"] = "pfmemberkiosk";
            envelope.tags['ai.device.roleName'] = "pfmemberkiosk";
        });
        appInsights.trackPageView();
    };

    if(_insightsConfig.config.instrumentationKey){
        kioskInsights.init();
    }
})(kioskInsights, ApplicationInsights = Microsoft.ApplicationInsights, config);
